import type { FieldValues, Resolver } from 'react-hook-form'

// The zod schemas are shared with the API route, so their rules and wording stay put. The form
// swaps the shown message for the editable one by matching on the schema's own text.
export function localiseResolver<T extends FieldValues>(
  resolver: Resolver<T>,
  messages: Record<string, string>
): Resolver<T> {
  const swap = (node: unknown) => {
    if (!node || typeof node !== 'object') return
    const entry = node as Record<string, unknown>
    if (typeof entry.message === 'string' && entry.message in messages) {
      entry.message = messages[entry.message]
    }
    for (const key of Object.keys(entry)) {
      if (key !== 'ref') swap(entry[key])
    }
  }
  return async (values, context, options) => {
    const result = await resolver(values, context, options)
    swap(result.errors)
    return result
  }
}
